import React from "react";
import Table from "sc/ui/components/Table";
import { connect } from "react-redux";
import { partnersPageLoad } from "../../actions/partners";
import { impersonate } from "../../actions/auth";
import { uiPartners, uiPartnersLoadInProgress } from "../../selectors/partners";
import { push } from "react-router-redux";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { Button, Glyphicon, Panel } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    partners: uiPartners(state),
    loading: uiPartnersLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(partnersPageLoad()),
    onAddPartner: () => dispatch(push("/partner/new")),
    onEditPartner: partnerId => dispatch(push(`/partner/edit/${partnerId}`)),
    onImpersonatePartner: partnerId => dispatch(impersonate(partnerId)),
  }),
)(
  componentWithLoadTrigger(props => {
    const actions = [
      {
        id: "edit-partner",
        text: " Edit",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-pencil",
        onClick: props.onEditPartner,
      },
      {
        id: "impersonate-partner",
        text: " Impersonate",
        className: "btn-success",
        glyph: "glyphicon glyphicon-log-in",
        onClick: props.onImpersonatePartner,
      },
    ];

    const columns = [
      {
        header: "Name",
        data: partner => partner.name,
      },
      {
        header: "Internal Id",
        data: partner => partner.internalId,
      },
    ];

    return (
      <div id="partners-page">
        <PageTitle title="Partners" />
        <Button
          id="add-partner"
          onClick={props.onAddPartner}
          className="btn-success"
        >
          <Glyphicon glyph="glyphicon glyphicon-plus" />
          &nbsp;Add New Partner
        </Button>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Partner list</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table
              data={props.partners}
              columns={columns}
              actions={actions}
              identityProperty="id"
              noDataMessage="No partners in the system"
              loading={props.loading}
              loadingMessage="Loading..."
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/admin/Partners.js